import ReadMoreText from "./ReadMoreText";
import { getTranslations } from "../utils/translations";

function EpisodeLayout({ episode, textColor = '#fff' }) {
  const t = getTranslations();
  console.log('Rendering EpisodeLayout for episode:', episode);
  console.log('❗❗❗ BROADCASTDESCRIPTION:', episode?.broadcastDescription);

  // Force a check to see what's in the episode object
  console.log('❗❗❗ ALL EPISODE KEYS:', Object.keys(episode || {}));

  return (
    <div id="episode-layout" style={{ marginTop: '15px', color: textColor }}>
      <span style={{ fontSize: '12px', color: textColor, float: 'right' }}>{episode?.description}</span>
      <h4 className="episode-insight-title" style={{ fontSize: '16px', color: textColor, margin: '0 0 10px', fontWeight: 'bold' }}>{t.episodeInsight}</h4>
      <ReadMoreText 
        key={episode?.guid || episode?.name}
        text={episode?.broadcastDescription} 
        seriesPage={episode?.seriesPage} 
        maxLength={125} 
        messageSpeaker={episode?.messageSpeaker}
        textColor={textColor}
      />
    </div>
  );
}

export default EpisodeLayout;
